import type { RouteLocation, RouteLocationRaw } from "vue-router";

/**
 * Finland had its own pages at /signup/fi and /signup/fi/:flow/:step; links in emails and
 * bookmarks still point there. Finland is now an ordinary country flow on the producer signup
 * page, so they land on the same path and step there, with the rest of their query kept.
 */
export function legacyFinlandSignupRedirect(
  to: RouteLocation
): RouteLocationRaw {
  const query: Record<string, string> = {};
  for (const [key, value] of Object.entries(to.query)) {
    if (typeof value === "string") query[key] = value;
  }
  query.country = "fi";
  const { flow, step } = to.params;
  if (flow === "authorization" || flow === "transfer") {
    query.addAuthorizationAgreement = String(flow === "authorization");
    query.step = step === "contract-review" ? "3" : "2";
  }
  return { path: "/signup/producer", query };
}
